import React, {
  useEffect,
  useState,
} from 'react';
import { useQuery } from '@apollo/client';
import classnames from 'classnames';
import Loader from 'react-loaders';
import { Link } from 'react-router-dom';
import {
  Get_Private_DataQuery,
  Get_Private_DataQueryVariables,
} from '../../../../../../../@types/graphql.d';
import { JsonApiCurrentUser } from '../../../../../../../@types/jsonapi.d';
import { WaterfallProps } from '../../../../@types/HeaderConfig.d';
import { currentRouterPathnameSelector } from '../../../../../../../selectors/router';
import { useSelector } from '../../../../../../../utils/hooks/useRedux';
import { GET_PRIVATE_DATA } from './MainMenuItemLink.gql';

import './MainMenuItemLink.scss';

interface MenuItemProps extends WaterfallProps {
  active: boolean;
  closeMainMenuMenu: () => void;
  currentUser: JsonApiCurrentUser;
}

function MainMenuItemLink({
  to,
  className,
  label,
  icon: IconComponent,
  active,
  closeMainMenuMenu,
  currentUser,
  risingEdge,
  faillingEdge,
  notificationKey,
}: MenuItemProps) {
  const { data } = useQuery<
  Get_Private_DataQuery,
  Get_Private_DataQueryVariables
  >(GET_PRIVATE_DATA);
  const notificationCount = notificationKey ? data?.localME?.[notificationKey] : undefined;
  const currentRoute = useSelector(currentRouterPathnameSelector);
  const [previousValue, setPreviousValue] = useState<boolean | undefined>(undefined);
  const [isRisingEdge, setIsRisingEdge] = useState(false);
  useEffect(() => {
    if (typeof risingEdge === 'function') {
      const newValue = risingEdge({ currentUser, currentRoute });
      if (previousValue !== undefined && newValue && previousValue !== newValue) {
        setIsRisingEdge(true);
      }
      setPreviousValue(newValue);
    }
    if (typeof faillingEdge === 'function') {
      if (isRisingEdge && faillingEdge({ currentUser, currentRoute })) {
        setIsRisingEdge(false);
      }
    }
  }, [currentUser, currentRoute]);
  if (!to) {
    return (
      <span className={classnames(className, 'main-menu-item-link')}>
        <span className="main-menu-item-label">
          {label}
        </span>
      </span>
    );
  }
  return (
    <Link
      to={to}
      className={classnames(className, {
        'main-menu-item-link': true,
        active,
      })}
      onClick={closeMainMenuMenu}
    >
      {IconComponent && (<IconComponent />)}
      <span className="main-menu-item-label">{label}</span>
      {(!!notificationCount) && (
        <span className="notification-count">
          {notificationCount}
        </span>
      )}
      { isRisingEdge && (
        <Loader
          type="ball-scale-multiple"
          active
        />
      )}
    </Link>
  );
}

export default MainMenuItemLink;
